import React from 'react';
import {
	AutocompleteInput,
	BooleanInput,
	Create,
	Datagrid,
	DateField,
	DateTimeInput,
	Edit,
	EditButton,
	List,
	ReferenceArrayInput,
	ReferenceInput,
	SaveButton,
	SelectArrayInput,
	SelectInput,
	SelectField,
	SimpleForm,
	TextInput,
	TextField,
	Toolbar,
	required, useEditContext, useRecordContext, CloneButton,
} from 'react-admin';

const messageType = [
	{ id: 'newBusiness', name: 'Новый партнер' },
	{ id: 'tradeUnionNews', name: 'Новости профсоюза' },
];

const messageStatus = [
	{ id: 1, name: 'В очереди' },
	{ id: 2, name: 'Обработано' },
];

const PushMessageEditToolbar = ({ disabled, ...props }) => (
	<Toolbar {...props}>
		<SaveButton
			label="Save"
			redirect="show"
			disabled={disabled}
		/>
	</Toolbar>
);

const PushMessageEditForm = ({ disabled, ...props }) => {
	return (
		<SimpleForm {...props} toolbar={<PushMessageEditToolbar disabled={disabled} />}>
			<DateTimeInput label="Отправлять после" source="sendAt" validate={[required()]} disabled={disabled} />
			<BooleanInput
				label="Всем"
				source="recipients.all"
				defaultValue={false}
			/>
			<BooleanInput
				label="Зарегистрированным"
				source="recipients.allRegistered"
				defaultValue={false}
			/>
			<ReferenceArrayInput
				label="Членам профсоюзов"
				source="recipients.tradeUnions"
				reference="TradeUnion"
			>
				<SelectArrayInput label="Членам профсоюзов" optionText="shortTitle" fullWidth />
			</ReferenceArrayInput>
			<TextInput label="Заголовок" source="title" validate={[required()]} disabled={disabled} fullWidth />
			<TextInput label="Сообщение" source="body" fullWidth multiline validate={[required()]} disabled={disabled} />
			<ReferenceInput
				source="business.id"
				reference="Business"
				sort={{ field: 'title.short', order: 'ASC' }}
			>
				<AutocompleteInput
					label="Партнер"
					optionText="title.short"
					emptyText="Не выбран"
					emptyValue={undefined}
					disabled={disabled}
					filterToQuery={(searchText) => ({ 'title.short': searchText })}
				/>
			</ReferenceInput>
			<SelectInput
				label="Тип"
				source="type"
				choices={messageType}
				validate={[required()]}
				defaultValue="newBusiness"
				disabled={disabled}
			/>
			<SelectInput label="Статус" source="status" choices={messageStatus} defaultValue={1} disabled />
		</SimpleForm>
	);
};

const EditForm = () => {
	const { record } = useEditContext();
	return <PushMessageEditForm disabled={record.status !== 1} />;
};

export const editPushMessage = (props) => {
	return (
		<Edit {...props}>
			<EditForm />
		</Edit>
	);
};

const pushMessageDefaultValue = { status: 1 };


export const createPushMessage = (props) => {
	return (
		<Create {...props}>
			<PushMessageEditForm
				defaultValues={pushMessageDefaultValue}
			/>
		</Create>
	);
};

const ClonePushMessageButton = () => {
	const record = useRecordContext();
	const sendAt = new Date();
	sendAt.setDate(sendAt.getDate() + 1);
	return (
		<CloneButton
			record={
				{
					...record, status: 1, id: undefined, sendAt,
				}
			}
		/>
	);
};

export const listPushMessage = (props) => {
	return (
		<List {...props} title="Push-уведомления">
			<Datagrid rowClick="edit">
				<DateField label="Отправлять после" source="sendAt" showTime />
				<TextField label="Заголовок" source="title" />
				<TextField label="Сообщение" source="body" />
				<SelectField label="Тип" source="type" choices={messageType} />
				<SelectField label="Статус" source="status" choices={messageStatus} />
				<EditButton />
				<ClonePushMessageButton />
			</Datagrid>
		</List>
	);
};
